import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";

import additionHelpers from "@common/components/helpers/addition";
import OfficerAction from "@common/redux/actions/OfficerAction";
import OfficerFormModalAction from "@common/redux/actions/OfficerFormModalAction";
import { searchOfficer } from "../helpers/Officer/searchOfficer";

const useOfficerForm = ({ handleNewOfficer }) => {
  const { loadingOfficers, officersOptions, officer } = useSelector((store) =>
    OfficerAction.getStatePath(store),
  );

  const methods = useFormContext();

  const officerTypeId = methods.watch("officerTypeId");

  const handleAddition = () => {
    OfficerFormModalAction.open(handleNewOfficer, {
      title: "Add New Officer",
    });
  };
  const { additionButton } = additionHelpers(handleAddition, false);

  const onSelect = (value) => {
    OfficerAction.editOfficer(value);
    methods.setValue("searchedOfficer", null);
    methods.setValue("officer", value);
  };

  const handleSearch = (searchQuery) =>
    searchOfficer(searchQuery, officerTypeId);

  return {
    methods,
    loadingOfficers,
    officer,
    officersOptions,
    officerTypeId,
    additionButton,
    handleAddition,
    handleSearch,
    onSelect,
  };
};

export default useOfficerForm;
